
<template>
  <div class="monitoring">
    <!-- 参数 -->
    <div v-if="sensors.length" class="flex sensors">
      <div v-for="(item, index) in sensors" :key="index">
        <div class="sen-box" :class="{ 'border': index }">
          <div class="sen-title font-13 text-muted">
            {{ item.sen_name }}
          </div>
          <div class="sen-value flex justify-content-center align-items-end mt-md">
            <!-- 数值型 -->
            <template v-if="item.sen_type === 1">
              <div class="number font-18 text-bold">{{ item.value ? item.value : '--' }}</div>
              <div v-if="item.unit" class="text-muted unit ml-xs">{{ item.unit }}</div>
            </template>
            <!-- 档位型 -->
            <template v-if="item.sen_type === 2">
              <div class="number font-18 text-bold">{{ item.value ? item.value : '--' }}</div>
            </template>
            <!-- 开关型 -->
            <span v-if="item.sen_type === 3">
              <template v-if="item.icon_url && item.icon_url_2">
                <img v-if="item.value === '1'" class="image mini" :src="item.icon_url_2" />
                <img v-else class="image mini" :src="item.icon_url" />
              </template>
              <template v-else>
                <img v-if="item.value === '1'" class="image mini" src="@/assets/default-sensor-on.svg" />
                <img v-else class="image mini" src="@/assets/default-sensor-off.svg" />
              </template>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 操作运行 -->
    <div class="mt-md">
      <el-row :gutter="30">
        <el-col :span="12">
          <div v-if="cur_workorder.principal && cur_workorder.principal.username" class="flex align-items-center pt pb pl pr card card-operator">
            <f-user-avatar :user="cur_workorder.principal" size="large" class="hd"></f-user-avatar>
            <div class="bd ml">
              <div class="text-bold">{{cur_workorder.principal.username}}</div>
              <div class="mt-sm">{{ '操作' }}</div>
            </div>
          </div>
          <div v-else class="flex align-items-center pt pb pl pr card card-operator">
            操作<span class="ml">--</span>
          </div>
          
        </el-col>
        <el-col :span="12">
          <div v-if="!stats.is_online" class="flex align-items-center pt pb pl pr card card-offline">
            设备已停机
          </div>
          <div v-if="stats.is_online && stats.is_running && !stats.is_alarm" class="flex align-items-center pt pb pl pr card card-running">
            设备正常运行
          </div>
          <div v-if="stats.is_online && stats.is_alarm" class="flex align-items-center pt pb pl pr card card-alarm">
            <span v-if="stats.last_alarm_title">{{ stats.last_alarm_title }}</span>
            <span v-else>{{ '设备告警'}}</span>
          </div>
          <div v-if="stats.is_online && !stats.is_running && !stats.is_alarm" class="flex align-items-center pt pb pl pr card card-online">
            设备正常待机
          </div>
        </el-col>
      </el-row>
    </div>

    <el-progress v-if="cur_workorder.workorderid" :text-inside="true" :stroke-width="26" :percentage="cur_workorder.percentage" class="mt-lg"  :format="formatNow"></el-progress>

    <el-progress v-if="next_workorder" :text-inside="true" :stroke-width="26" :percentage="100" class="mt-md" color="#409EFF" :format="formatNext"></el-progress>

    <div v-if="equipid" class="mt-lg">
      <monitor-line :equipid="equipid" :random="new_random" :effective="effective" />
    </div>
  </div>
</template>

<script>
import { equipMonitorApi } from '@/api/em/detailApi'

export default {
  components: {
    MonitorLine: () => import('./MonitorLine')
  },

  props: {
    equipid: {
      type: Number,
      default() {
        return 0
      }
    },

    random: {
      type: [Number, String],
      default: 0
    },
  },

  data() {
    return {
      stats: {},
      cur_workorder: {},
      next_workorder: '',
      sensors: [],
      effective: {},

      new_random: ''
    }
  },

  watch: {
    random: function(newVal,oval) {
      if (this.equipid) this.fetchData()
    }
  },

  created() {
    if (this.equipid) this.fetchData()
  },

  methods: {
    fetchData() {
      this.loading = true
      equipMonitorApi({ equipid: this.equipid }).then(res => {
        this.loading = false
        if (res.errno === 0) {
          this.new_random = this.equipid + '-' + (+new Date())
          this.stats = Object.assign({}, res.data)
          this.cur_workorder = Object.assign({}, res.data.cur_workorder)
          this.effective = Object.assign({}, res.data.effective)
          this.next_workorder = res.data.next_workorder
          this.sensors = res.data.sensors
          if (this.cur_workorder.workorderid) {
            let cur_workorder = Object.assign({}, this.cur_workorder)
            const nowtime = parseInt(new Date().getTime() / 1000)
            if (cur_workorder.status == 20) cur_workorder.percentage = 20
            if (cur_workorder.status >= 80) cur_workorder.percentage = 100
            if ((cur_workorder.starttime && !cur_workorder.endtime) || (cur_workorder.starttime && cur_workorder.status < 80)) {
              cur_workorder.percentage = ((nowtime - cur_workorder.starttime) / (cur_workorder.plan_endtime - cur_workorder.plan_starttime)) * 100 < 100 ? ((nowtime - cur_workorder.starttime) / (cur_workorder.plan_endtime - cur_workorder.plan_starttime)) * 100 : 100
              if ((cur_workorder.status == 30 || cur_workorder.status == 50) && cur_workorder.percentage >= 100) cur_workorder.percentage = 95
            }
            this.cur_workorder.percentage = cur_workorder.percentage
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },

    formatNow(percentage) {
      return '当前工单 ' + this.cur_workorder.workorder_no + ' / ' + this.cur_workorder.workorder_title
    },

    formatNext(percentage) {
      return '下一个工单 ' + this.next_workorder
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-progress-bar__inner {
  text-align: left;
  padding: 0 10px;
}
/deep/ .el-progress-bar__innerText {
	color: #333;
}
.monitoring {
  width: 100%;
  .sensors {
    flex-wrap: wrap;
  }
  .sen-box {
    width: 100px;
    height: 100px;
    background: #eef0f5;
    padding: 8px;
    border-bottom: 1px solid #eaeaea;
    .sen-value {
      line-height: 28px;
    }
    .unit {
      line-height: 22px;
    }
  }
  .border {
    border-left: 1px solid #eaeaea;
  }
  .card {
    height: 80px;
    border-radius: 4px;
  }
  .card-operator {
    background-color: #F8F9FC;
  }
  .card-offline {
    background-color: whitesmoke;
    color: #999999;
  }
  .card-online {
    background-color: #fdf6ec;
    color: #e6a23c;
  }
  .card-alarm {
    background-color: #fef0f0;
    color: #f56c6c;
  }
  .card-running {
    background-color: #e6f9ef;
    color: #07c160;
  }
}
</style>
